<div class="toast-container">
    @for (toast of toastService.toasts(); track toast.id) {
      <div class="toast" [ngClass]="toast.type">
        <span>{{ toast.message }}</span>
        
        @if (toast.actionText) {
          <button class="action-btn" (click)="handleAction(toast)">
            {{ toast.actionText }}
          </button>
        }
        
        <button class="close-btn" (click)="toastService.remove(toast.id)">✖</button>
      </div>
    }
  </div>